import { storage } from '../../../server/Firebase';

const USERS_DIRECTORY = 'users';
const ACTS_DIRECTORY = 'acts';
export const UPLOAD_STATE_CHANGED = 'state_changed';
export const getUserActStorageReference = (userId, actId, uploadId) =>
  storage.ref().child(`${USERS_DIRECTORY}/${userId}/${ACTS_DIRECTORY}/${actId}/${uploadId}`);
